<template>
  <div class="fourElements">
    <div class="fourElementsContainer">
      <div class="oh fl mr20">
        <div class="fl lh30">品牌：</div>
        <div class="fl">
          <a-select
            ref="select"
            v-model:value="searchParams.brandId"
            style="width: 120px"
            @change="getTableList"
          >
            <a-select-option
              :value="item.id"
              :key="key"
              v-for="(item, key) in brands"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </div>
      </div>

      <div class="oh fl mr20">
        <div class="fl lh30">渠道：</div>
        <div class="fl">
          <a-select
            ref="select"
            v-model:value="searchParams.channelId"
            style="width: 120px"
            @change="getTableList"
          >
            <a-select-option
              :value="item.id"
              :key="key"
              v-for="(item, key) in channels"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </div>
      </div>

      <div class="oh fl  mr20">
        <div class="fl lh30">站点：</div>
        <div class="fl">
          <a-select
            ref="select"
            v-model:value="searchParams.siteId"
            style="width: 120px"
            @change="getTableList"
          >
            <a-select-option
              :value="item.id"
              :key="key"
              v-for="(item, key) in sites"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </div>
      </div>
      <div class="oh fl">
        <div class="fl lh30">终端：</div>
        <div class="fl">
          <a-select
            ref="select"
            v-model:value="searchParams.terminalId"
            style="width: 120px"
            @change="getTableList"
          >
            <a-select-option :value="1" key="web">WEB</a-select-option>
            <a-select-option :value="2" key="app">APP</a-select-option>
          </a-select>
        </div>
      </div>
      <a-button type="primary" class="btn" @click="newBuild">新建实验</a-button>
    </div>
  </div>
</template>
<script>
import { inject, reactive, toRefs, watchEffect } from 'vue'
import {
  collection_special_save,
  collection_special_query
} from '@/server/modules/41299.js'
import { message } from 'ant-design-vue'
export default {
  setup() {
    const initData = inject('initState')
    const state = reactive({
      isVisible1: false,
      checked: true,
      prompt: true,
      sync: true,
      confirmLoading: false,
      configParams: {
        prompt: '',
        sync: '',
        promptId: '',
        syncId: '',
        siteId: ''
      },
      // computed(() => ({
      //   prompt: state.prompt ? 0 : 1, //是否弹出终端提示 0-不弹出，1-弹出
      //   sync: state.sync ? 1 : 0 // 是否同步web端权重原始值， 0-不同步，1-同步
      // })),
      handleOk() {
        state.saveCollectionConifg()
      },
      showModal() {
        state.getCollectionConfig()
        state.isVisible1 = true
      },
      async saveCollectionConifg() {
        try {
          state.confirmLoading = true
          const params = {
            ...state.configParams
          }
          params.prompt = state.prompt ? 1 : 0
          params.sync = state.sync ? 1 : 0
          params.siteId = initData.searchParams.siteId

          let { success, retInfo } = await collection_special_save(params, {
            isFilter: true
          })
          if (success) {
            state.isVisible1 = false
            state.getCollectionConfig()
          } else {
            message.error(retInfo)
          }
          state.confirmLoading = false
        } catch (error) {
          console.log('error', error)
          state.confirmLoading = false
        }
      },
      async getCollectionConfig() {
        let { success, data, retInfo } = await collection_special_query(
          initData.searchParams.siteId
        )
        if (success) {
          state.configParams = data
          state.prompt = data.prompt === 1 ? true : false
          state.sync = data.sync === 1 ? true : false
        } else {
          message.error(retInfo)
        }
      }
    })

    watchEffect(() => {
      if (initData.searchParams.siteId) {
        state.getCollectionConfig()
      }
    })

    return {
      ...toRefs(initData),
      ...toRefs(state)
    }
  }
}
</script>
<style scoped>
.fourElements {
  background: #ffffff;
  padding: 10px 20px 0px 0px;
  height: 45px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
}

.fourElementsContainer {
  display: flex;
  flex-direction: row;
}

.btn {
  position: absolute;
  right: 50px;
}
</style>
